(function() {

	"use strict"

	angular.module( "ATMGurus" )

	/**
	*
	*	Unsafe sce context escaping
	*
	*
	*/

	.filter( 'unsafe', [
		"$sce",
		function( $sce ) {
			// return $sce.trustAsHtml;
			return function( text ) {
				return $sce.trustAsHtml( text )
			}
		}
	] )


}())


// WEBPACK FOOTER //
// ./src/app/filters/unsafe.js